import Header from "../../components/shared/Header";
import "../../styles/shared/Plans.scss";
import HeroImage from "../../images/verifiers.png";
import SolutionImage3 from "../../images/verifier.png";
import Focus from "../../images/Frame 2147228646.png";
import { useState, useEffect } from "react";
import GreenLogo from "../../images/Group 32.png";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/shared/Footer";
import ContactUs from "../../components/shared/ContactUs";
import VerifierFaq from "../../components/NewLandingPage/VerifierFaq";


export default function Verifiers() {
  const navigate = useNavigate();
  const [type, setType] = useState("verification");
  const [planVideo, setplanVideo] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);


  const handleModalOPen = () => {
    setModalOpen(true);
  };

useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="plans">
      <Header />
      <div className="hero">
        <div className="hero__inner">
          <div className="hero__inner__title">
            CloseCarbon <span>Verifiers</span>
          </div>
          <div className="hero__inner__subtitle">
 Verification. Integrity. Digital Carbon Assets.          </div>
          <div className="hero__inner__price">
            Starting at ₦0.00 <span>Free</span>
          </div>
          <div className="hero__inner__button-group">
            <button
              onClick={() => navigate('/template/verifier')}
            >Choose plan</button>
            <button
             onClick={() => {
              window.open("https://youtu.be/xK5PMog-SMA?si=OPK0_Ee9H5uERYy4", "_blank", "noopener,noreferrer");
            }}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.155 13.7501C3.96313 13.7497 3.77466 13.6994 3.60812 13.6041C3.23312 13.3916 3 12.9791 3 12.5313V3.46881C3 3.01974 3.23312 2.60849 3.60812 2.39599C3.77863 2.298 3.97232 2.24761 4.16896 2.25009C4.36559 2.25256 4.55796 2.30781 4.72594 2.41006L12.4712 7.04631C12.6327 7.14752 12.7657 7.28807 12.858 7.45479C12.9502 7.6215 12.9986 7.8089 12.9986 7.99943C12.9986 8.18996 12.9502 8.37736 12.858 8.54408C12.7657 8.71079 12.6327 8.85134 12.4712 8.95256L4.72469 13.5901C4.55278 13.694 4.35588 13.7493 4.155 13.7501Z"
                  fill="#0FA958"
                />
              </svg>
              Watch now
            </button>
          </div>

          <img loading="lazy" className="hero__inner__img" src={HeroImage} alt="" />
        </div>
      </div>
      <div className="solution">
        <div className="solution__title">
          The <span>solution</span>  you need for the sustainability journey you want
        </div>
        <div className="solution__subtitle">
The CloseCarbon Verifiers Plan is designed for professionals and institutions responsible for ensuring the accuracy and credibility of emissions data within the ecosystem.         </div>
        <div className="solution__grid">
          <div className="solution__grid__nav">
            <div
              className={
                type === "verification"
                  ? "solution__grid__nav__item solution__grid__nav__item-active"
                  : "solution__grid__nav__item"
              }
              onClick={() => setType("verification")}
            >
              <div className="solution__grid__nav__item__title">
                Verification
              </div>
              {type === "verification" && (
                <div className="solution__grid__nav__item__subtitle">
A streamlined dashboard, structured workflows, and secure digital infrastructure designed to support accurate, standard-aligned verification processes.                 </div>
              )}
            </div>
          </div>
          {type === "verification" && (
            <img loading="lazy" src={SolutionImage3} className="solution__grid__img" />
          )}
        </div>
      </div>

      <div className="seamless seamless-verifier">
        <div className="seamless__card1">
          <div className="seamless__card1__title">
          Seamless guide to becoming a verifier
          </div>
          <div className="seamless__card1__subtitle">
          Whether you're just beginning your sustainability journey or aiming to enhance your commitment, the verifier plan offers a pivotal role in ensuring the accuracy and integrity of emission data. 
<br />
<br />
Get our CCRT from decentralized market like (Uniswap, Pancakeswap)
          </div>
          <div className="seamless__card1__button-group">
            <button
            onClick={() => navigate('/template/verifier')}
            >Choose plan</button>
            <button
            onClick={handleModalOPen}
            >
              Contact us
            </button>
          </div>
        </div>
        <div className="seamless__card2">
          <div className="seamless__card2__group">
            <div>1</div>
            <div>
              <div>Fill out the provided template</div>
              <div>Complete the template provided on the website with your relevant details. This information will be used to verify your identity and qualifications as a verifier.</div>
            </div>
          </div>
          <div className="seamless__card2__group">
            <div>2</div>
            <div>
              <div>Sign up</div>
              <div>Register and sign up to finalize the process. Upon completion, you'll officially become a verifier and be ready to start verifying emission data for CloseCarbon users.</div>
            </div>
          </div>
          <div className="seamless__card2__group">
            <div>3</div>
            <div>
              <div>Purchase CloseCarbon tokens</div>
              <div>Obtain CCRT (CloseCarbon Tokens) from the decentralized market. These tokens will be used for staking and participating in the verification process.</div>
            </div>
          </div>
          <div className="seamless__card2__group">
            <div>4</div>
            <div>
              <div>Stake your CloseCarbon tokens</div>
              <div>Stake your CCRT tokens to demonstrate your commitment and involvement in the verification process. Staking helps ensure the integrity of the verification system.</div>
            </div>
          </div>
        </div>
      </div>

      <div className="unlock">
        <div className="unlock__card1">
          <div className="unlock__card1__title">
          Unlock the potential of <br/> <span className="text-[#0D924F]"> Verifiers plan</span>
          </div>
          <div className="unlock__card1__subtitle">
          Whether you're new to verifying emissions or looking to enhance your role, the verifier plan offers the groundwork for making impactful strides in environmental accountability.
          </div>
          <img loading="lazy" className="unlock__card1__img" src={Focus} alt="" />
        </div>
        <div className="unlock__card2">
          <div className="unlock__card2__flex">
            <img loading="lazy" src={GreenLogo} />
            <div>
              <div className="text-[20px] font-semibold">Verifiers</div>
            </div>
           
         <div className="text-[#0D924F] text-6xl font-bold ml-80"> ₦0.00
            <div className="text-end mt-2 text-gray-500">Free</div>

               </div>
             
          </div>
          <div className="unlock__card2__price">
        
          </div>
          <div className="unlock__card2__divider"></div>
          <div className="unlock__card2__more-info">
            <div className="unlock__card2__more-info__title">How it works:</div>
             <div className="unlock__card2__more-info__flex">
               <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="13" fill="#F0F2F5"/>
<path d="M10.842 10.8327C10.7683 9.8763 10.9893 8.92024 11.4753 8.09322C11.9614 7.2662 12.6891 6.60793 13.5606 6.20701C14.432 5.8061 15.4054 5.68177 16.3497 5.85078C17.2939 6.01979 18.1637 6.47401 18.842 7.15232C19.5203 7.83062 19.9746 8.70044 20.1436 9.6447C20.3126 10.589 20.1883 11.5623 19.7873 12.4338C19.3864 13.3053 18.7282 14.033 17.9011 14.519C17.0741 15.0051 16.1181 15.2261 15.1616 15.1523" stroke="#475367" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.2179 16.6107C20.2179 17.1853 19.9896 17.7364 19.5833 18.1427C19.177 18.5491 18.6259 18.7773 18.0512 18.7773H16.6068M18.0512 20.2218L16.6068 18.7773L18.0512 17.3329M5.77344 9.38846C5.77344 8.81382 6.00171 8.26272 6.40804 7.85639C6.81437 7.45006 7.36547 7.22179 7.9401 7.22179H9.38455M7.9401 5.77734L9.38455 7.22179L7.9401 8.66623M10.4679 20.2218C9.22284 20.2218 8.02879 19.7272 7.14841 18.8468C6.26803 17.9664 5.77344 16.7724 5.77344 15.5273C5.77344 14.2823 6.26803 13.0882 7.14841 12.2079C8.02879 11.3275 9.22284 10.8329 10.4679 10.8329C11.7129 10.8329 12.907 11.3275 13.7874 12.2079C14.6677 13.0882 15.1623 14.2823 15.1623 15.5273C15.1623 16.7724 14.6677 17.9664 13.7874 18.8468C12.907 19.7272 11.7129 20.2218 10.4679 20.2218Z" stroke="#475367" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


                  <div>
Emission Data Verification: Review and assess project emissions and reduction data to ensure compliance with recognized carbon methodologies and reporting standards.                   </div>
                </div>
                <div className="unlock__card2__more-info__flex">
                 <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="13" fill="#F0F2F5"/>
<path d="M7.03843 7.04102C7.03843 6.61004 7.20964 6.19671 7.51438 5.89197C7.81913 5.58722 8.23246 5.41602 8.66343 5.41602H14.1733C14.604 5.41625 15.0171 5.58751 15.3216 5.89214L18.4795 9.04897C18.7841 9.35374 18.9552 9.76699 18.9551 10.1978V18.9577C18.9551 19.3887 18.7839 19.802 18.4791 20.1067C18.1744 20.4115 17.7611 20.5827 17.3301 20.5827H14.053C14.0913 20.3951 14.0893 20.2016 14.0473 20.0149C14.0053 19.8281 13.9241 19.6524 13.8093 19.4993H17.3301C17.4738 19.4993 17.6115 19.4423 17.7131 19.3407C17.8147 19.2391 17.8718 19.1013 17.8718 18.9577V10.8327H15.1634C14.7325 10.8327 14.3191 10.6615 14.0144 10.3567C13.7096 10.052 13.5384 9.63866 13.5384 9.20768V6.49935H8.66343C8.51977 6.49935 8.382 6.55642 8.28042 6.658C8.17883 6.75958 8.12177 6.89736 8.12177 7.04102V12.2226C7.74839 12.2726 7.38378 12.3744 7.03843 12.5248V7.04102ZM15.1634 9.74935H17.6475L14.6218 6.7236V9.20768C14.6218 9.35134 14.6788 9.48912 14.7804 9.5907C14.882 9.69228 15.0198 9.74935 15.1634 9.74935ZM8.66343 19.4993C9.36543 19.4993 10.0154 19.2773 10.5463 18.8981L12.343 20.6948C12.4451 20.7935 12.582 20.8481 12.724 20.8468C12.866 20.8456 13.0019 20.7886 13.1023 20.6882C13.2027 20.5878 13.2597 20.4519 13.2609 20.3099C13.2622 20.1679 13.2076 20.0311 13.1089 19.9289L11.3127 18.1327C11.7349 17.539 11.9454 16.8206 11.9103 16.0928C11.8752 15.3651 11.5966 14.6703 11.1193 14.1199C10.6419 13.5695 9.99345 13.1955 9.278 13.0579C8.56255 12.9202 7.82161 13.027 7.17412 13.361C6.52663 13.695 6.01015 14.2369 5.70758 14.8996C5.40501 15.5624 5.33391 16.3076 5.5057 17.0156C5.67748 17.7237 6.08218 18.3534 6.65483 18.8039C7.22748 19.2543 7.93487 19.4992 8.66343 19.4993ZM8.66343 18.416C8.0888 18.416 7.5377 18.1877 7.13137 17.7814C6.72504 17.3751 6.49677 16.824 6.49677 16.2493C6.49677 15.6747 6.72504 15.1236 7.13137 14.7173C7.5377 14.311 8.0888 14.0827 8.66343 14.0827C9.23807 14.0827 9.78917 14.311 10.1955 14.7173C10.6018 15.1236 10.8301 15.6747 10.8301 16.2493C10.8301 16.824 10.6018 17.3751 10.1955 17.7814C9.78917 18.1877 9.23807 18.416 8.66343 18.416Z" fill="#475367"/>
</svg>


                  <div>
Structured Verification Workflow: Access tools that support documentation review, methodology checks, and approval processes in a transparent and auditable manner.                   </div>
                </div>
               
            <button
              className="hero-btn mt-10 group text-[16px] text-white flex justify-center items-center border-2 border-[#E4E7EC] py-[3px] gap-[10px] w-[150px]  h-[56px] bg-[#0D924F] rounded-xl hover:bg-[#0d713f] transition-all cursor-pointer  hover:-translate-y-0.5 "
              onClick={() => setplanVideo(true)}
            >
            Choose plan
            </button>
          </div>
        </div>
      </div>
 <div className="bg-[#D3EEE0]">
<VerifierFaq/>

      </div>
      <ContactUs
       handleModalOPen={handleModalOPen}
       setModalOpen={setModalOpen}
       modalOpen={modalOpen}
      />

      <Footer />
      
    </div>
  );
}
